import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import {
  DefaultWorkspaceUserFeatures,
  WorkspaceUserFeatures
} from 'src/models/workspaceUserFeatures.interface';
import type { AppThunk } from 'src/store';
import { resetWorkspace } from 'src/store/extraActions';
import axiosCore from 'src/utils/axiosCore';

interface WorkspaceUserState {
  features: WorkspaceUserFeatures;
}

const initialState: WorkspaceUserState = {
  features: DefaultWorkspaceUserFeatures
};

const slice = createSlice({
  name: 'workspaceUser',
  initialState,
  reducers: {
    setWorkspaceFeaturesLoading(state) {
      state.features.loading = true;
    },
    getWorkspaceUserFeatures(
      state: WorkspaceUserState,
      action: PayloadAction<WorkspaceUserFeatures>
    ) {
      state.features = action.payload;
    },
    getOrganisationUserFeatures(
      state: WorkspaceUserState,
      action: PayloadAction<WorkspaceUserFeatures>
    ) {
      state.features = action.payload;
    }
  },
  extraReducers: {
    [resetWorkspace.type]() {
      return initialState;
    }
  }
});

export const reducer = slice.reducer;

export const getWorkspaceUserFeatures =
  (workspaceId: string): AppThunk =>
  async (dispatch) => {
    const response = await axiosCore.get<{ data: any }>(
      `/workspaces/${workspaceId}/user-feature`
    );
    dispatch(slice.actions.getWorkspaceUserFeatures(response.data.data));
  };

export const getOrganisationUserFeatures =
  (organisationId: string): AppThunk =>
  async (dispatch) => {
    const response = await axiosCore.get<{ data: any }>(
      `/organisations/${organisationId}/user-feature`
    );
    dispatch(slice.actions.getOrganisationUserFeatures(response.data.data));
  };

export const { setWorkspaceFeaturesLoading } = slice.actions;

export default slice;
